const BASE_URL = process.env?.REACT_APP_SOCKET_BASE_URL||process.env?.REACT_APP_API_BASE_URL;

const config = {
    baseUrl: BASE_URL,
    apiBaseUrl: `${BASE_URL}/api/`,
    socketBaseUrl: BASE_URL,
    siteKey: process.env.REACT_APP_SITE_KEY,
    // A *separate* reCAPTCHA v2 (visible checkbox) site key — v2 and v3 are
    // different Google products and cannot share a key. Register one at
    // https://www.google.com/recaptcha/admin for "reCAPTCHA v2 / Checkbox"
    // and set REACT_APP_RECAPTCHA_V2_SITE_KEY; pair it with
    // RECAPTCHA_V2_SECRET on the backend (services/recaptcha-Services.js).
    recaptchaV2SiteKey: process.env.REACT_APP_RECAPTCHA_V2_SITE_KEY,
    googleMapApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
    REACT_APP_USERTOUR_TOKEN: process.env.REACT_APP_USERTOUR_TOKEN,
};
export default config;